import { TableV2 as Table } from "@asayinc/component-library";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ROW_OPTIONS } from "src/constants/options/rowOptions";
import { useTablePagination } from "src/hooks/useTablePagination";
import { useNoboEventsQuery } from "src/store/noboEvent";
import { getColumnData, getRowData, NOBO_EVENTS_COLUMNS } from "./utils";
import { INoboEvent } from "src/store/noboEvent/types";
import { ScrollContainer } from "src/components/containers/ScrollContainer";

export function IssuerNoboEvents() {
  const { id: issuerId } = useParams();
  const navigate = useNavigate();

  const {
    getSort,
    offset,
    limit,
    ordering,
    onChangePage,
    onChangeRows,
    onOrderingChange,
  } = useTablePagination();
  const { data, isFetching, isLoading } = useNoboEventsQuery({
    offset,
    limit,
    ordering,
    issuerId,
  });

  const paginateProps = {
    onChangePage,
    onChangeRows,
    rowOptions: ROW_OPTIONS,
    count: data?.count || 0,
    page: Math.floor(offset / limit) + 1,
    rowsPerPage: limit,
  };

  const handleRowClick = (event: INoboEvent) => {
    const { id } = event;
    navigate(`/nobo-events/${id}/details`, {
      state: { backLink: `/issuers/${issuerId}/nobo-events` },
    });
  };

  const columns = useMemo(() => NOBO_EVENTS_COLUMNS, []);
  const columnData = useMemo(() => {
    return getColumnData({
      getSort,
      onOrderingChange,
    });
  }, [getSort, onOrderingChange]);
  const rowData = getRowData(data?.results || [], handleRowClick);

  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
      <Table
        count={data?.count || 0}
        columnData={columnData}
        columns={columns}
        isFetching={isFetching}
        isLoading={isLoading}
        noResultsData={{
          title: "No Share Range Analysis Events found",
          subtitle:
            "Sorry, there are no Share Range Analysis Events that match your applied filters.",
        }}
        paginateProps={paginateProps}
        rows={rowData}
        tableMinWidth={1100}
        title="Nobo Events"
        titleVariant="subtitle2"
        toolbarInside
      />
    </ScrollContainer>
  );
}
